// Keeps the page title, description, canonical URL and sharing tags in step
// with the current route during in-app navigation. The first load already has
// the right values in the HTML file (scripts/prerender-routes.js); this covers
// moving between pages without a reload, which is also what Google sees when
// it renders the app. Unknown paths get noindex so they never reach search.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import site from "./pages.json";

export function findPage(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return site.pages.find((page) => page.path === path) || null;
}

function setMeta(doc, key, name, value) {
  let tag = doc.head.querySelector(`meta[${key}="${name}"]`);
  if (!tag) {
    tag = doc.createElement("meta");
    tag.setAttribute(key, name);
    doc.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
}

export function applyPageMeta(doc, pathname) {
  const page = findPage(pathname);
  let robots = doc.head.querySelector('meta[name="robots"]');

  if (!page) {
    if (!robots) {
      robots = doc.createElement("meta");
      robots.setAttribute("name", "robots");
      doc.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex");
    return;
  }

  if (robots) robots.remove();
  const url = `${site.origin}${page.path}`;
  doc.title = page.title;
  setMeta(doc, "name", "description", page.description);
  setMeta(doc, "property", "og:url", url);
  setMeta(doc, "property", "og:title", page.title);
  setMeta(doc, "property", "og:description", page.description);
  setMeta(doc, "name", "twitter:title", page.title);
  setMeta(doc, "name", "twitter:description", page.description);

  let canonical = doc.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = doc.createElement("link");
    canonical.setAttribute("rel", "canonical");
    doc.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);
}

const RouteMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    applyPageMeta(document, pathname);
  }, [pathname]);
  return null;
};

export default RouteMeta;
